import { Typography, Box, useTheme, Card, CardHeader, CardContent, Alert, Chip, TextField, Divider, Autocomplete, Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import React, { useState, useEffect } from "react";



import InfoIcon from '@mui/icons-material/Info';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../../Layout/Alertbar";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

const AddExtraSetProduction = ({ onClose, handleBackWinderMachineEntry, open, viewWinderParentRollDetail, winderMONumber, winderMANumber, selectedcombination, actualSetLength, setWeight, selectedCore, setDiameter, sharedLength, sharedQty, totalJoints, noLength,parentRollId }) => {


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const [operatorList, setOperatorList] = useState([]);
    const [result, setresult] = useState([]);
    const [operatorCode, setOperatorCode] = useState('');
    const [operatorEmailID, setOperatorEmailID] = useState('');
    const [isDataLoaded, setIsDataLoaded] = useState(false);


    //message are 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const [selectedSetID, setSelectedSetID] = useState();
    const [availableLot, setAvailableLot] = useState([]);
    const [addSetCount,setAddSetCount]=useState(0);
    const [saveDisable,setSaveDisable]=useState(false);

    const DetailRow = ({ label, value }) => (
        <Grid container item xs={12}>
            <Grid item xs={6}>
                <Typography variant="subtitle2" textAlign="left">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="subtitle2" textAlign="right" fontWeight="bold">
                    {value}
                </Typography>
            </Grid>
        </Grid>
    );



    const callback = () => {
        handleBackWinderMachineEntry();
    };

    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setOperatorList(data);

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isDataLoaded]);



    const handleSaveOperator = () => {

        setParentRollMsgOpen(false);
        // validation 
        let isValid = true;
        let validation_msg = '';

        if (selectedSetID === '') {
            validation_msg += 'Please select Set number for duplication process.\n';
            isValid = false;
        }

        if (addSetCount === '') {
            validation_msg += 'Please enter add extra set count.\n';
            isValid = false;
        } 


        if (isValid) {
            const SaveData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_user_name:localStorage.getItem('userID'),
                p_release_no:winderMONumber,
                p_lot_no:winderMANumber,
                p_duplicate_set_count:addSetCount,
                p_selected_set:selectedSetID,
                p_parent_roll_id:parentRollId,
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_ADD_EXTRA_SET, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].result_value == 0) {
                            // Show a notification when the PDF is downloaded successfully
                            toast.success('Additional Set Was Added Successfully.', { position: toast.POSITION.BOTTOM_CENTER });                          
                            onClose();
                        }
                        else{
                            // Show a notification when the PDF is downloaded successfully
                            toast.success('Unable to Add Extra set value, Kindly check network connection.', { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        else {

            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }


    };

    const handleSelectLotNumberStatusID = (event, value) => {

        if (value !== undefined && value !== null) {
            setSelectedSetID(value.set_id);
        }
    };

    useEffect(() => {
        if (selectedcombination?.length > 0) {
            let setcount = selectedcombination[0].sets;
            let templist = [];

            // Populate templist with set_id objects
            for (let i = 1; i <= setcount; i++) {
                templist.push({ set_id: i });
            }
            setAvailableLot(templist);
            setSelectedSetID(templist[0]);
        }

    }, [selectedcombination])


    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    {/* <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> Add icon with some margin */}
                    <Typography>Add Extra Set</Typography>
                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>

                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 1 }} >
                        <Grid item xs={12} sm={12} md={8} lg={12} xl={12}  >
                            <Box marginTop={1}>
                                {viewWinderParentRollDetail && (
                                    <>
                                        {selectedcombination?.[0]?.combinations && (
                                            <>
                                                <Card sx={{ borderRadius: "12px", boxShadow: 3, marginLeft: "auto" }} >
                                                    <CardHeader
                                                        title="Selected Parent Roll MO & MA Details"
                                                        avatar={<InfoIcon color="secondary" />}
                                                        sx={{ backgroundColor: colors.primary[400], padding: "8px" }}
                                                    />
                                                    <CardContent sx={{ padding: "12px" }}>
                                                        <Typography variant="subtitle2" gutterBottom>
                                                            Selected MO #
                                                            <Chip
                                                                label={winderMONumber}
                                                                color="success"
                                                                size="small"
                                                                sx={{ ml: 1, fontWeight: "bold" }}
                                                            />
                                                        </Typography>
                                                        <Typography variant="subtitle2" gutterBottom>
                                                            MA #
                                                            <Chip
                                                                label={winderMANumber}
                                                                color="success"
                                                                size="small"
                                                                sx={{ ml: 1, fontWeight: "bold" }}
                                                            />
                                                        </Typography>
                                                        <Divider sx={{ my: 1.5 }} />

                                                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                            <strong>Combination:</strong> {selectedcombination?.[0]?.combinations ?? 0}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                            <strong>Total Sets:</strong> {selectedcombination?.[0]?.sets ?? 0}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                            <strong>Produced Sets:</strong> {selectedcombination?.[0]?.p_set ?? 0}
                                                        </Typography>

                                                        {actualSetLength !== 0 && setWeight && (
                                                            <>
                                                                <Divider sx={{ my: 1.5 }} />
                                                                {/* <Accordion elevation={1} sx={{ margin: "0 -8px" }}>
                                                                                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                                                            <Typography variant="subtitle2" fontWeight="bold">
                                                                                                                Detailed Metrics
                                                                                                            </Typography>
                                                                                                        </AccordionSummary>
                                                                                                        <AccordionDetails sx={{ padding: "8px" }}> */}
                                                                <Grid container spacing={1}>
                                                                    <DetailRow label="Total Set Weight" value={setWeight || 0} />
                                                                    <DetailRow
                                                                        label="Core ID / Diameter"
                                                                        value={`${selectedCore || 0}/${setDiameter || 0}`}
                                                                    />
                                                                    {sharedLength > 0 && (
                                                                        <>
                                                                            <DetailRow label="Joined Length" value={sharedLength || 0} />
                                                                            <DetailRow label="Joined Length Weight" value={sharedQty || 0} />
                                                                            <DetailRow label="Total Joints in Child Reel" value={totalJoints || 0} />
                                                                        </>
                                                                    ) || null}
                                                                </Grid>
                                                                {/* </AccordionDetails>
                                                                                                    </Accordion> */}
                                                            </>
                                                        ) || null}
                                                        {noLength && (
                                                            <Alert severity="warning" sx={{ mt: 1.5 }}>
                                                                No balance length is available for this MA number.
                                                            </Alert>
                                                        )}
                                                    </CardContent>
                                                </Card>
                                            </>
                                        ) || null}
                                    </>
                                ) || null}
                            </Box>





                            <Divider sx={{ marginTop: '20px' }} />
                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={2}
                                marginBottom={1}
                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Duplicate set</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 8',
                                        xl: 'span 8',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Autocomplete
                                        value={selectedSetID}
                                        onChange={handleSelectLotNumberStatusID}
                                        size="small"
                                        options={availableLot}
                                        fullWidth
                                        getOptionLabel={(option) => `${option.set_id}`} // Assuming lot numbers are strings
                                        renderInput={(params) => (
                                            <TextField sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '2px',
                                                    textAlign: 'left',
                                                },
                                            }} {...params} variant="outlined" />
                                        )}
                                    />

                                </Box>
                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                                marginBottom={2}
                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Additional Sets</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 8',
                                        xl: 'span 8',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField value={addSetCount} onChange={(e) => setAddSetCount(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="number" inputProps={{ min: 0 }} ></TextField>
                                </Box>



                            </Box>


                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>

            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Box display="flex" justifyContent="flex-end">
                    <Button onClick={handleSaveOperator} size="small" variant="contained" color="secondary">
                        Save
                    </Button>
                    <Button size='small' onClick={onClose} variant="contained" color="secondary" style={{ textTransform: 'none', marginLeft: '10px' }} >
                        Cancel
                    </Button>
                </Box>

            </DialogActions>

        </Dialog>
    );
};
export default AddExtraSetProduction;